export default function PHP_Functions() {
  return (
    <div>
      <h1>PHP_Functions</h1>
    </div>
  );
}
